export default theme => ({
  blockContainer: {
    position: 'relative',
    height: '100%',
    width: '100vw',
    minWidth: '1400px',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      position: 'relative',
      height: 'initial',
      // minHeight: '100%',
      width: '100%',
      minWidth: 'initial',
      padding: 0,
      background: theme.palette.blue.main,
    },
  },
  background: {
    position: 'absolute',
    zIndex: 1,
    height: '100%',
    width: '100vw',
    minWidth: '1400px',
    backgroundColor: theme.palette.blue.main,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  topBlueCurve: {
    position: 'absolute',
    zIndex: 2,
    top: '-15%',
    right: '20%',
    height: '45%',
    width: '40%',
    background: `no-repeat url(${theme.url('/blocks/b28-top-blue-curve.svg')})`,
    backgroundSize: 'contain',
    backgroundPosition: 'right top',
  },
  bottomBlueCurve: {
    position: 'absolute',
    zIndex: 2,
    bottom: 0,
    left: 0,
    height: '30%',
    width: '30%',
    background: `no-repeat url(${theme.url('/blocks/b28-bottom-blue-curve.svg')})`,
    backgroundSize: 'contain',
    backgroundPosition: 'left bottom',
  },
  content: {
    position: 'absolute',
    zIndex: 5,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    color: theme.palette.secondary.main,
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      width: '100%',
      minWidth: 'initial',
      height: 'initial',
      top: 'initial',
      left: 'initial',
      transform: 'initial',
    },
  },
  mainTitle: {
    zIndex: 5,
    padding: `0 ${theme.spacing(6)}px 0 ${theme.spacing(6)}px`,
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      top: 0,
      left: 0,
      textAlign: 'right',
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  main: {
    display: 'flex',
    padding: theme.spacing(6),
    [theme.breakpoints.down('md')]: {
      display: 'block',
      padding: theme.spacing(2),
      paddingBottom: 0,
    },
  },
  bold: {
    fontWeight: 'bold',
  },
  desc: {
    flex: '1 1 0',
    paddingRight: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      padding: 'initial',
      paddingBottom: theme.spacing(2),
      display: 'block',
    },
  },
  list: {
    flex: '3 1 0',
    paddingLeft: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      padding: 'initial',
      paddingBottom: 0,
      display: 'block',
    },
  },
});
